export default __webpack_public_path__ + "static/media/homeowners.6ca48bd1.jpg";